export const StateNameMaxLength = 4;
